export const PROJECT_BLOCKER_TAGS = {
  PROJECT_BLOCKERS: "ProjectBlockers",
  PROJECT_BLOCKER: "ProjectBlocker",
} as const;
